import data from "../assets/address/state.json";
import { FormGroup, Label, Col } from "reactstrap";
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import '../App.css';
import '../styles/eInvoice.css';

export const CountryStatesInput = ({ isCountry, isState, isRequired, onChange, defaultCountry, defaultState, isDisabled = false, }) => {
  const styles = {
    label: {
      width: '30%',
      fontSize: '14px',
      fontWeight: '500',
      marginLeft: '12px'
    },
    input: {
      width: '65%',
      padding: '0px'
    }
  }

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      borderRadius: '20px',
      fontSize: '14px',
      paddingLeft: '10px',
      border: '1px solid #5A46AA',
      boxShadow: 'none',
      outline: 'none',
    '&:hover': {
      borderColor: '#5A46AA',
      boxShadow: 'none',
    },
      transition: 'border-color 0.3s ease',
      backgroundColor: state.isDisabled ? '#CCCCCC' : 'white',
      color: 'black',
    }),
    input: (provided, state) => ({
      ...provided,
      fontSize: '14px',
      color: 'black',
      backgroundColor: state.isDisabled ? '#CCCCCC' : 'transparent',
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: 'black',
      backgroundColor: state.isDisabled ? '#CCCCCC' : 'transparent',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#5A46AA'
        : state.isFocused
        ? '#A1AAD9'
        : 'transparent',
      color: state.isSelected ? 'white' : 'black',
      cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    }),
  };
  
  
  const countries = data.Countries.map((country) => ({
    value: country.CountryName,
    label: country.CountryName,
  }));

  const [selectedCountry, setSelectedCountry] = useState(defaultCountry === undefined || defaultCountry === null? undefined :{value: defaultCountry, label: defaultCountry});
  const [selectedState, setSelectedState] = useState(defaultState === undefined || defaultState === null? undefined :{value: defaultState, label: defaultState});
  const [availableStates, setAvailableStates] = useState([]);

  useEffect(()=>{
    // console.log(selectedState, selectedCountry)
    if(onChange != undefined)
        onChange(selectedCountry, selectedState)
  }, [selectedState, selectedCountry])


  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setSelectedState(null);
    if (selectedOption) {
      const countryStates = data.Countries.find(
        (country) => country.CountryName === selectedOption.value
      ).States;
      const statesOptions = countryStates.map((state) => ({
        value: state.StateName,
        label: state.StateName,
      }));
      setAvailableStates(statesOptions);
    } else {
      setAvailableStates([]);
    }
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
  };

  return (
    <div>
      {isCountry && (
        <FormGroup row className="custom-form-group">
          <Label sm={3} style={styles.label}>Country: <span style={{ color: 'red' }}>*</span></Label>
          <Col sm={9} style={styles.input} className="country-state-responsive">
            <Select
              value={selectedCountry}
              onChange={handleCountryChange}
              options={countries}
              isClearable
              isSearchable
              isCreatable
              styles={customSelectStyles}
              isDisabled={isDisabled}
              isRequired={isRequired}
            />
          </Col>
        </FormGroup>
      )}
      {isState && (
        <FormGroup row>
          <Label sm={3} style={styles.label}>State: <span style={{ color: 'red' }}>*</span></Label>
          <Col sm={9} style={styles.input} className="country-state-responsive">
            <Select
              value={selectedState}
              onChange={handleStateChange}
              options={availableStates}
              isClearable
              isSearchable
              isCreatable
              styles={customSelectStyles}
              isDisabled={isDisabled}
              isRequired={isRequired}
            />
          </Col>
        </FormGroup>
      )}
    </div>
  );
};
